import cx from 'classnames';
import { Contact } from 'src/types/dealInsights';
import { map, size } from 'lodash';
import styles from './styles.module.scss';
import moment from 'moment';
import Text from 'src/components/text';
import Truncate from "src/components/truncate";
import Tooltip from "src/components/tooltip";

interface DealContactsProps {
  contacts: Contact[];
  isLoading: boolean;
}

const emptyImg = '/images/dealInsights/noContacts.svg';

const EmptyMessage = ({ msg }: { msg?: string }) => (
  <div className={styles.emptyMsg}>
    <img src={emptyImg} alt="No results" className={styles.emptyStateImg} />
    <p className={styles.emptyStateMsg}>{msg ?? 'No contacts found!'}</p>
  </div>
);

const DefaultUserAvatar = '/images/default_user_profile_background.png';

const IndicatorDots = ({ value }: { value: number }) => {
  let count = 1;
  let color = 'red';

  if (value >= 70) {
    count = 3;
    color = 'green';
  } else if (value >= 35) {
    count = 2;
    color = 'orange';
  }

  return (
    <div className={styles.indicators}>
      {Array.from({ length: 3 }).map((_, i) => (
        <span
          key={i}
          className={cx(
            styles.dot,
            i < count && styles[color] // apply color only for active dots
          )}
        />
      ))}
    </div>
  );
};

const ContactsPlaceholder = () => {
  return( <div className={cx(styles.placeholder, styles.contactsPlaceholder)}>
   <div className={styles.card}>
        <span className={cx(styles.block, )} />
    </div>
    <div className={styles.card}>
        <span className={cx(styles.block,)} />
    </div>
 </div>
)};

export const DealContacts = ({ contacts, isLoading }: DealContactsProps) => {
  return (
    <div className={styles.contactsContainer}>
      <h3 className={styles.title}>Deal Contacts {!isLoading ? `(${size(contacts)})` : ''}</h3>
      {isLoading ?
       <ContactsPlaceholder/>
        : <>
        { size(contacts) === 0 ?
           <EmptyMessage/> : <div className={styles.contactsList}>
            {map(contacts, (contact) => (
            <div key={contact.externalId} className={styles.contactCard}>
              <div className={styles.avatar}>
                {contact.fullName ? <div className={styles.avatarPlaceholder}>
                  {contact.fullName?.charAt(0) || '-'}
                </div> : <img src={DefaultUserAvatar} alt={'avatar'} className={styles.avatarImg} />}
              </div>

              <div className={styles.content}>
                <div className={styles.info}>
                  <div className={styles.name}>
                     <Text text={contact.fullName || '-'} tooltip={{ placement: "auto" }} />
                  </div>
                  {(contact?.title || contact?.lastActivityDate) && (
                    <div className={styles.details}>
                      {contact.title && <Tooltip content={contact.title} placement='top'>
                        <div className={styles.title}>
                          <Truncate lines={1} width={contact.lastActivityDate ? 200 : undefined}>
                            {contact.title}
                          </Truncate>
                        </div> </Tooltip> }
                      {contact.lastActivityDate && contact.title && <span className={styles.divider}></span>}
                      {contact.lastActivityDate && <p>Last activity: {moment(contact.lastActivityDate).format("DD MMM'YY")}</p>}
                    </div>
                  )}
                </div>

                {/* <div className={styles.status}>
                  <IndicatorDots value={contact.point} />
                </div> */}
              </div>
            </div>
             ))}  </div> }
        </> }
    </div>
  );
};

export default DealContacts;
